import React, { useState, useRef, useEffect, useContext } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Bag from "./Bag";
import Notiflix from "notiflix";
import { endpoint } from "./endpoint";
import { UserContext } from './UserContext'; // Import UserContext

const BagsList = ({ bagsStatus, handleBagSelection, selectedBags, handleButtonClick }) => {
  const checkboxesRef = useRef([]);
  const [revealedBags, setRevealedBags] = useState({});
  const [error, setError] = useState('');
  const [bags, setBags] = useState(bagsStatus);
  const { user } = useContext(UserContext); // Access user data from context

  useEffect(() => {
    setBags(bagsStatus);
  }, [bagsStatus]);

  // Toggles the visibility of a specific bag's ID
  const handleToggle = (bagId) => {
    setRevealedBags((prevRevealedBags) => ({
      ...prevRevealedBags,
      [bagId]: !prevRevealedBags[bagId],
    }));
  };

  const handleRemoveBag = async (bag) => {
    if (bag.inOrder) {
      setError('Cannot remove a bag that is in use.');
      return;
    }

    Notiflix.Confirm.show("Remove bag", "Are you sure you want to remove this bag?", "Yes", "No", async () => {
      try {
        const response = await fetch(`${endpoint}/gymapp/removebag.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ bagId: bag.id, userId: user.id }), // Include user ID in the request if needed
        });

        const data = await response.json();

        if (data.status === 'success') {
          // Handle successful removal
          Notiflix.Notify.success(`Bag ${bag.id} removed successfully.`);
          // Update the local state to remove the deleted bag
          setBags(prevBags => prevBags.filter(b => b.id !== bag.id));
        } else {
          // Handle failure response
          setError(data.message || 'Failed to remove the bag.');
        }
      } catch (error) {
        console.error('Error removing bag:', error);
        setError('An error occurred while trying to remove the bag.');
      }
    });
  };

  const handleButtonClick2 = (bagId) => {
    if (checkboxesRef.current[bagId]) {
      checkboxesRef.current[bagId].click();
    }
  };

  return (
    <>
      <div className="container">
        <div className="row">
          {bags.map((bag) => (
            <div
              key={bag.id}
              className="text-center col-lg-3"
              style={{
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                borderRadius: "8px",
                transition: "box-shadow 0.3s ease",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "10px",
                marginBottom: "10px"
              }}
            >
              <center><Bag /></center>
              <div style={{ background: "transparent", border: "none", boxShadow: "none" }}>
                <font style={{ color: "black" }} onClick={() => handleToggle(bag.id)}>
                  {/* Display the full ID if revealed, else show last 4 digits */}
                  {revealedBags[bag.id] ? bag.id : bag.id.slice(-4).padStart(bag.id.length, '*')}
                  {" "}
                  {revealedBags[bag.id] ? <FaEyeSlash color="black" /> : <FaEye color="black" />}
                </font>
                <font style={{ opacity: "0.9", color: "grey", marginLeft: "10px" }}>
                  {bag.inOrder ? "This bag is in use." : ""}
                </font>
              </div>
              <center>
                <button
                  className="btn btn-light btn-ltd"
                  style={{ background: "#d3d4d5", width: "200px", margin: "auto", marginTop: "10px" }}
                  onClick={() => handleRemoveBag(bag)}
                  disabled={bag.inOrder} // Disable button if bag is in use
                >
                  Remove bag
                </button>
              </center>
            </div>
          ))}
        </div>
      </div>
      {error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}
      <br /><br /><br />
    </>
  );
};

export default BagsList;
